"use client";

import { useState } from "react";
import { ArrowDown, ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheVisualLegacy() {
  const galleryItems = [{
    src: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-09-at-15.15.21.jpeg?v=yxe7zgv5fbf",
    srcset: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/687251575_18438635893188782_8326311397016682442_n-2.jpg?v=1m002cqf61fj-wvc-srcset",
    sizes: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/687251575_18438635893188782_8326311397016682442_n-2.jpg?v=lrz02tc3h5q-wvc-sizes",
    alt: "Client tattoo photo 1",
    caption: "Client Work — Photo 1",
    aspect: "aspect-square"
  }, {
    src: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-09-at-13.56.33.jpeg?v=kjzm01um6e8",
    srcset: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-09-at-13.56.33.jpeg?v=h4fznncb2wg-wvc-srcset",
    sizes: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-09-at-13.56.33.jpeg?v=une08slogeb-wvc-sizes",
    alt: "Client tattoo photo 2",
    caption: "Client Work — Photo 2",
    aspect: "aspect-square"
  }, {
    src: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-09-at-15.16.09.jpeg?v=98hyhffmwor",
    srcset: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/476043957_18373144096188782_4227562941129711351_n-1.jpg?v=6gg4ct0la8i-wvc-srcset",
    sizes: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/476043957_18373144096188782_4227562941129711351_n-1.jpg?v=207pcnsuq4v-wvc-sizes",
    alt: "Client tattoo photo 3",
    caption: "Client Work — Photo 3",
    aspect: "aspect-square"
  }, {
    src: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/WhatsApp-Image-2026-06-09-at-13.59.33.jpeg?v=61f20rn4z64",
    srcset: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/624625424_18016092554810096_7627825621887997483_n-1.jpg?v=e4izy5ae3j-wvc-srcset",
    sizes: "https://better-malamute.10web.cloud/wp-content/uploads/2026/06/624625424_18016092554810096_7627825621887997483_n-1.jpg?v=fl4jcu7rcqo-wvc-sizes",
    alt: "Client tattoo photo 4",
    caption: "Client Work — Photo 4",
    aspect: "aspect-square"
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const {
    ref: headRef,
    isVisible: headVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const handlePrev = () => {
    if (openIndex === null) return;
    setOpenIndex((openIndex - 1 + galleryItems.length) % galleryItems.length);
  };
  const handleNext = () => {
    if (openIndex === null) return;
    setOpenIndex((openIndex + 1) % galleryItems.length);
  };
  const columns: typeof galleryItems[] = [[], []];
  galleryItems.forEach((item, i) => {
    columns[i % 2].push(item);
  });
  const mobileColumns: typeof galleryItems[] = [[], []];
  galleryItems.forEach((item, i) => {
    mobileColumns[i % 2].push(item);
  });
  return <section data-section-id="2647" id="the-visual-legacy" className="bg-background text-foreground py-[100px] overflow-hidden">
      <div ref={headRef} className={`max-w-[1600px] mx-auto px-6 md:px-12 transition-all duration-1000 ease-out ${headVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="font-mono text-xs md:text-sm uppercase tracking-widest text-primary">
            The Visual Legacy — №01
          </div>
          <h2 className="font-default text-3xl md:text-[3.5rem] leading-tight text-foreground md:text-right">
            <span className="text-primary">W</span>here Ink Becomes Legend.
          </h2>
        </div>
      </div>

      <div className="mt-20 px-2 md:px-3">
        <div className="hidden md:grid grid-cols-2 gap-3">
          {columns.map((col, colIdx) => <div data-index={colIdx} key={colIdx} className="flex flex-col gap-3">
              {col.map((item, i) => {
            const globalIndex = galleryItems.indexOf(item);
            return <Button key={globalIndex} data-index={i} onClick={() => setOpenIndex(globalIndex)} variant="ghost" className={`group relative overflow-hidden rounded-md ${item.aspect} w-full h-auto p-0 cursor-pointer focus-visible:ring-2 focus-visible:ring-primary`}>
                    <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.04] grayscale hover:grayscale-0" style={{
                transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
              }} />
                    <div className="absolute inset-0 pointer-events-none opacity-10 mix-blend-overlay" style={{
                backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E\")"
              }} />
                  </Button>;
          })}
            </div>)}
        </div>

        <div className="flex md:hidden gap-2">
          {mobileColumns.map((col, colIdx) => <div data-index={colIdx} key={colIdx} className="flex-1 flex flex-col gap-2">
              {col.map((item, i) => {
            const globalIndex = galleryItems.indexOf(item);
            return <Button key={globalIndex} data-index={i} onClick={() => setOpenIndex(globalIndex)} variant="ghost" className={`group relative overflow-hidden rounded-md ${item.aspect} w-full h-auto p-0 cursor-pointer`}>
                    <img src={item.src} data-wvc-srcset={item.srcset} data-wvc-sizes={item.sizes} alt={item.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover grayscale" />
                    <div className="absolute inset-0 pointer-events-none opacity-10 mix-blend-overlay" style={{
                backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' /%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E\")"
              }} />
                  </Button>;
          })}
            </div>)}
        </div>
      </div>

      <div className="mt-[60px] text-center px-6">
        <p className="font-default text-base md:text-lg text-muted-foreground inline-flex items-center gap-2 uppercase tracking-widest">
          Explore the portfolio
          <ArrowDown className="size-4 text-primary" />
        </p>
      </div>

      <Dialog open={openIndex !== null} onOpenChange={open => !open && setOpenIndex(null)}>
        <DialogContent showCloseButton={true} className="max-w-[95vw] sm:max-w-[90vw] md:max-w-5xl bg-background p-4 md:p-6 border-border rounded-md">
          {openIndex !== null && <div className="flex flex-col gap-4">
              <div className="relative w-full bg-secondary rounded-md overflow-hidden border border-border">
                <img src={galleryItems[openIndex].src} data-wvc-srcset={galleryItems[openIndex].srcset} data-wvc-sizes={galleryItems[openIndex].sizes} alt={galleryItems[openIndex].alt} className="w-full max-h-[70vh] object-contain" />
              </div>
              <div className="flex items-center justify-between gap-4">
                <Button variant="ghost" size="icon" onClick={handlePrev} aria-label="Previous image" className="rounded-md shrink-0 hover:bg-primary hover:text-primary-foreground">
                  <ChevronLeft className="size-5" />
                </Button>
                <div className="flex-1" />
                <Button variant="ghost" size="icon" onClick={handleNext} aria-label="Next image" className="rounded-md shrink-0 hover:bg-primary hover:text-primary-foreground">
                  <ChevronRight className="size-5" />
                </Button>
              </div>
            </div>}
        </DialogContent>
      </Dialog>
    </section>;
}